import { render } from "./NoteComment.vue?vue&type=template&id=6ca1d888"
import script from "./NoteComment.vue?vue&type=script&lang=js"
export * from "./NoteComment.vue?vue&type=script&lang=js"

import "./NoteComment.vue?vue&type=style&index=0&id=6ca1d888&lang=css"

import exportComponent from "/home/forge/staging.ordinocrm.com/releases/20260610000542/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__